import { Box, Chip, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { ReactNode, useState } from 'react';
import { DASHBOARD_LIST_COLUMN_WIDTHS } from 'src/utils/dashboardSortUtils';

import { ListColumn } from '../../../components/lists/ListColumn';
import { ListItem } from '../../../components/lists/ListItem';
import { EControlPositionType, EPositionType, IEnrichedUniswapPosition } from '../../../types/uniswapTokens';
import { RangeIndicator } from '../../../components-yldr/RangeIndicator/RangeIndicator';
import { AlmMarketChip } from '../../../ui-kit/AlmMarketChip';
import { EStrategyProvider } from '../../../hooks/yldr/useAlmPoolQuery';
import { ListPoolIcon } from './ListPoolIcon';

interface ListItemWrapperProps extends IEnrichedUniswapPosition {
  children: ReactNode;
  details?: ReactNode;
  almMarketName?: EStrategyProvider;
  isManual?: boolean;
  isAutomatic?: boolean;
}

export const ListItemExpandedWrapper = ({
  token0,
  token1,
  fee,
  children,
  details,
  lowerPosition,
  upperPosition,
  type,
  poolPrice,
  marketName,
  controlType,
  almMarketName,
  isManual,
  isAutomatic,
  ...rest
}: ListItemWrapperProps) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const onToggleRow = () => {
    if (type !== EPositionType.Pool) {
      setExpanded((prevState) => !prevState);
    }
  };

  return (
    <ListItem {...rest} sx={{ flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', height: '72px', width: '100%', alignItems: 'center' }}>
        <ListColumn
          maxWidth={DASHBOARD_LIST_COLUMN_WIDTHS.POOL}
          minWidth={DASHBOARD_LIST_COLUMN_WIDTHS.POOL}
          isRow
        >
          <Box onClick={onToggleRow}>
            <KeyboardArrowDownIcon
              sx={{
                width: '20px',
                ml: '-6px',
                mt: '4px',
                mr: '12px',
                transform: expanded ? 'none' : 'rotate(270deg)',
                cursor: type === EPositionType.Pool ? 'default' : 'pointer',
                opacity: type === EPositionType.Pool ? 0.4 : 1,
              }}
            />
          </Box>
          <ListPoolIcon
            iconSymbolTokenA={token0.iconSymbol}
            iconSymbolTokenB={token1.iconSymbol}
            marketName={marketName}
          />
          <Box sx={{ ml: 3, width: '100%' }}>
            <Box sx={{ display: 'flex', marginBottom: '1px' }}>
              <Typography variant="subheader1" noWrap>
                {token0.symbol}/{token1.symbol}
              </Typography>
              {Boolean(fee) && type !== EPositionType.Pool && (
                <Typography variant="main14" sx={{ color: '#62677B', pl: '4px' }}>
                  {fee}%
                </Typography>
              )}
            </Box>
            {type === EPositionType.Pool && (
              <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                {isAutomatic && <Chip label="ALM" />}
                {isManual && <Chip label="Manual" />}
              </Box>
            )}
            {controlType === EControlPositionType.ManualPosition && type !== EPositionType.Pool && (
              <RangeIndicator
                lowerPosition={lowerPosition}
                upperPosition={upperPosition}
                currentPrice={poolPrice}
                symbolTokenA={token0.symbol}
                symbolTokenB={token1.symbol}
              />
            )}
            {controlType === EControlPositionType.AlmPosition && (
              <AlmMarketChip almMarketName={almMarketName} />
            )}
          </Box>
        </ListColumn>
        {children}
      </Box>
      {expanded && details}
    </ListItem>
  );
};
